import React from 'react'

export default function Skill() {
    return (
        <section id="skill" className="text-center">
            <h1>Skills</h1>
            <div className="skills">
                <div className='container'>
                    <p><i className="uil uil-arrow"></i>Python</p>
                    <div className="container">
                        <div className="skill python">90%</div>
                    </div>
                    <p><i className="uil uil-arrow"></i>Django</p>
                    <div className="container">
                        <div className="skill django">90%</div>
                    </div>
                    <p><i className="uil uil-react"></i>React.Js</p>
                    <div className="container">
                        <div className="skill react">75%</div>
                    </div>
                    <p><i className="uil uil-code-branch"></i>Git</p>
                    <div className="container">
                        <div className="skill git">80%</div>
                    </div>
                    <p><i className="uil uil-html5"></i>Html</p>
                    <div className="container">
                        <div className="skill html">100%</div>
                    </div>

                    <p><i className="uil uil-css3-simple"></i>Css</p>
                    <div className="container">
                        <div className="skill css">80%</div>
                    </div>

                    <p><i className="uil uil-java-script"></i>JavaScript</p>
                    <div className="container">
                        <div className="skill js">65%</div>
                    </div>
                </div>
            </div>
        </section>
    )
}
